import { AdvancePaymentsSettingsForm } from './AdvancePaymentsSettingsForm';
import { AdvancePaymentsSettingsFormLoader } from './AdvancePaymentsSettingsForm.loader';
import { formInitializer } from './AdvancePaymentsSettingsForm.utils';
import { AdvancePaymentsSettingsSaveButton } from './AdvancePaymentsSettingsSaveButton';

export const AdvancePaymentsSettings = (): JSX.Element => {
   return (
      <AdvancePaymentsSettingsFormLoader>
         {({ refundConfiguration, refetchRefundConfiguration }) => (
            <AdvancePaymentsSettingsForm initializer={formInitializer(refundConfiguration)}>
               {({ handleSubmit, markPristine }) => (
                  <AdvancePaymentsSettingsSaveButton
                     handleSubmit={handleSubmit}
                     onSuccess={() => {
                        markPristine();
                        refetchRefundConfiguration();
                     }}
                  />
               )}
            </AdvancePaymentsSettingsForm>
         )}
      </AdvancePaymentsSettingsFormLoader>
   );
};
